import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-suetonius',
  imports: [Link],
  templateUrl: './suetonius.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './suetonius.scss',
})
export class Suetonius {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Suetonius`);
    this.dynamicTitle.description(`Suetonius mentions a figure named "Chrestus" who was involved in disturbances among Jewish people in Rome during the reign of Claudius.`);
  }
}
